import { IProject } from './interfaces';

const projects: IProject[] = [
  {
    title: 'Chitransh',
    description:
      "It's a social media web app where users can create post with caption and upload multiple images, like/dislike/save posts and  make a comment on it, search people, follow and unfollow people, see people profile with their following and followers list, see people to follow suggestion list.I have used tech like React, styled-components, Webpack 5, Material-icons, Firebase.",
    liveLink: 'https://chitransh.netlify.app/',
    codeLink: 'https://github.com/ddepu11/Chitransh',
    images: [
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/1.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/2.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/3.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/4.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/5.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/6.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/7.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/8.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/9.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/10.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/11.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/12.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/13.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/chitransh/14.png?raw=true',
    ],
  },

  {
    title: 'Movil Shop',
    description:
      "This is an E-commerce web app for selling mobiles made with MERN stack and it has features like add to cart, place an order, add your billing address, Seller and Admin dashboard, Sellers can add mobile with it's images he can also update it's details, Admin can delete users and sellers, also used Styled-Components for styling, Redux for state management, Authentication using JWT, Login via Google.",
    liveLink: 'https://movil-shop.netlify.app/',
    codeLink: 'https://github.com/ddepu11/movil_shop_client_side_react',
    images: [
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movil-shop/1.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movil-shop/2.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movil-shop/3.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movil-shop/4.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movil-shop/5.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movil-shop/6.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movil-shop/7.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movil-shop/8.png?raw=true',
    ],
  },

  {
    title: 'Movies DB',
    description:
      "As it's name suggests it's a app which consumes themoviedb api and lists movies, it has features like/dislike and save to watch later movie, wath movie's trailers/clips, create a new playlist and add movie in it, list movies accoring to genere and scroll down to fetch more movies, view movie details. Made this app using, React, Styled-components, Webpack 5, Material-icons, Firebase.",
    liveLink: 'https://movies-dbt.netlify.app/',
    codeLink: 'https://github.com/ddepu11/movies-db',
    images: [
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movies-db/1.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movies-db/2.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movies-db/3.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movies-db/4.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movies-db/5.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movies-db/6.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movies-db/7.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/movies-db/8.png?raw=true',
    ],
  },

  {
    title: 'Sangeetmay',
    description:
      "It's a Music Player web app it has features like play/pause song, mute/unmute volume, like or dislike the song,  list songs and playlists, list liked songs, Admin can upload and delete song with its image. Made it with TypeScript, React, Styled-components, Webpack 5, React-icons, Firebase.",
    liveLink: 'https://sangeetmay.netlify.app/',
    codeLink: 'https://github.com/ddepu11/sangeetmay',
    images: [
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/1.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/2.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/3.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/4.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/5.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/6.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/7.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/8.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/sangeetmay/9.png?raw=true',
    ],
  },

  {
    title: 'Social Chat Rooms',
    description:
      "It's a simple messaging web app where people can create chat rooms and have chat with random people, users can  update his account info. Made it with React, Styled-components, Webpack 5, React-icons, Firebase.",
    liveLink: 'https://social-chat-rooms.netlify.app/',
    codeLink: 'https://github.com/ddepu11/social_chat_rooms',
    images: [
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/social-chat-rooms/1.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/social-chat-rooms/2.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/social-chat-rooms/3.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/social-chat-rooms/4.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/social-chat-rooms/5.png?raw=true',
      'https://github.com/ddepu11/my_first_portfolio/blob/main/projects/social-chat-rooms/6.png?raw=true',
    ],
  },
];

export default projects;
